<template>
	<div id="rightBar">
		<div class="rightBar">
			<div class="goldList" :style="'top:-'+(34+parseInt(46*ritNum))+'px'">
				<li v-for="(item,index) in goldList" v-if="index > goldListIndex">
					<img :class="'anim'+parseInt(Math.random()*4 +1)" v-for="item in item" src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/doller.png">
				</li>
			</div>

			<audio src="https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/musics/glod.mp3" id="glodsound" class="glodsound"></audio>

			<div class="siders" :style="'height:'+46*(ritNum-1)+'px'">
				<a @click="onToUserInfo" class="userimg" :class="'user'+styleType">
					<img :src="headerUrl" />
				</a>

				<a v-if="isShowInvitation" :class="'yao'+styleType" @click="onGotoInvitaion">
					<img :src="imgPath+'home/yao.png'" />
				</a>

				<a v-if="isShowRedPack" :class="'shang'+styleType" @click="onShangBtnClicked">
					<img :src="imgPath+'home/shang.png'" />
				</a>

				<a v-if="isShowCall" :class="'tel'+styleType" :href="iphoneNum">
					<img :src="imgPath+'home/tel.png'" />
				</a>

				<a v-if="showQR" @click="onCloseQRCode" class="codeImg" :class="'code'+styleType">
					<img :src="imgPath+'home/code.png'" />
				</a>

				<a @click="onTimg" class="codeImg" :class="'code'+styleType">
					<img :src="imgPath+'home/timg.png'" />
				</a>
			</div>

			<a class="stretch" @click.stop="stretch" :class="[{closeside:!stretchStatus},'switch'+styleType]">
				<img :src="imgPath+'home/switch.png'" />
			</a>
		</div>

		<!--微信二维码-->
		<van-popup v-model="isShowQRimg" :close-on-click-overlay='false' class="codebox">
			<div>
				<p v-if="qrCodeStr" class="title">{{qrCodeStr}}</p>
				<p v-else class="title">长按关注公众号</p>
				<img :src="qrCodeUrl" class="code stop" />
				<p class="text">关注二维码，了解更多信息</p>
			</div>
			<img v-if="followed" @click="onCloseQRCode" :src="imgPath+'code-close.png'" class="close">
		</van-popup>

		<!--小程序二维码-->
		<van-popup v-model="isShowTimg" class="codebox"  :lazy-render="false">
			<div>
				<p class="title">小程序观看直播</p>
				<div class="code stop"  id="qrcode"></div>
				<p class="text">小程序观看直播，更快更流畅</p>
			</div>
			<img @click="onTimg" :src="imgPath+'code-close.png'" class="close">
		</van-popup>

		<!--发红包-->
		<van-popup v-model="sendredbag"  :lazy-render="false">
			<rewardRedBag @close='closeAction' :fans_id='fans_id' ></rewardRedBag>
		</van-popup>
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../kits/Tools.js';
import vxxData from '../../kits/data.js';
import rewardRedBag from './rewardRedBag.vue';
import QRCoder from 'qrcoder';

export default {
	data() {
		return {
			imgPath:'',
			goldList:[],
			goldListIndex:-1,
			stretchStatus: false,
			delayNum: true,
			qrCodeUrl: "",
			qrCodeStr: "",
			showQR: false,
			isShowQRimg: false,
			followed: true,
			sendredbag: false, //发红包
			ritMenuNum: 2,
			ritNum:1,
			isShowInvitation: false,
			isShowRedPack: false,
			isShowCall: false,
			iphoneNum: "",
			isShowTimg:false,
			glodsound:'',
			ds_id:'',
			stretchTimer:null
		}
	},
	components: {
		rewardRedBag,
	},
	props:['styleType','fans_id','headerUrl'],
	mounted() {
		this.glodsound = document.getElementById('glodsound');
		this.ds_id = tool.getQueryDsId();
		this.imgPath = tool.imgPath();
		// this.getHeaderUrl();
		this.getCodeImg();
	},
	methods: {
		getCodeImg(){
			var link = tool.baseUrl1()+'/live?ds_id='+this.ds_id+'&sid='+this.fans_id;
			// var qrcoder = new QRCoder({
			// 	data: link,
			// 	size: 225
			// });
			new QRCode('qrcode', {
			  text: link,
			  width: 256,
			  height: 256,
			  colorDark: '#000000',
			  colorLight: '#ffffff'
			});
		},
		getHeaderUrl(){
			// var that = this;
			// var timer = setInterval(function(){
			// 	if(that.headerUrl){
			// 		clearInterval(timer);
			// 	}else{
			// 		var current_app_Id = window.localStorage.getItem("current_app_Id");
			// 		var fans = JSON.parse(window.localStorage.getItem(current_app_Id));
			// 		if(fans&&(typeof fans)!="string"){
			// 			that.headerUrl = fans.header;
			// 		}
			// 	}
			// },500)
		},
		stretch() {
			this.stretchStatus = !this.stretchStatus;
			this.delayNum = false;
			if(this.stretchStatus) {
				this.ritNum = 1;
				clearInterval(this.stretchTimer)
			} else {
				this.ritNum = this.ritMenuNum;
			}
		},
		unStretch() {
			var that = this;
			document.body.addEventListener('click', function() {
				if(!that.stretchStatus) {
					that.stretch();
				}
			});
		},
		onToUserInfo() {
			this.$router.push({
				name: 'UserInfo'
			});
		},
		onGotoInvitaion() {
			this.$router.push({
				name: 'InviteCard'
			});
		},
		onShangBtnClicked() {
			this.sendredbag = true;
		},
		onCloseQRCode() {
			this.isShowQRimg = !this.isShowQRimg;
			this.delay();
		},
		onTimg(){
			this.isShowTimg = !this.isShowTimg;
		},
		buyProduct(json){
			var that = this;
			var arr = parseInt(Math.random()*3+1);
			that.goldList.push(arr);
			setTimeout(function(){
				that.goldList.push(arr);
			},Math.random()*400+100);
			setTimeout(function(){
				that.goldListIndex+=2;
				console.log(that.goldListIndex)
			},6000)
			this.glodsound.play();
		},
		delay() {
			var that = this;
			if(!this.delayNum){
				return;
			}
			this.stretchTimer = setTimeout(function() {
				that.stretch();
				that.unStretch();
			}, 5000)
		},
		closeAction() {
			this.sendredbag = false;
		},
		dsFunc(Obj){

			if(Obj.wx_follow && this.styleType != 4) { //微信关注二维码
				
				this.qrCodeUrl = Obj.wx_follow.pic_url;
				this.qrCodeStr = Obj.wx_follow.remark;
				this.desc = Obj.wx_follow.wx_withdraw_des;
				if(!vxxData.isShowQRimg) {
					vxxData.isShowQRimg = true;
					this.isShowQRimg = true;
				}
				if(Obj.wx_follow.float != 'no') {
					this.showQR = true;
					this.ritMenuNum++;
				}
				if(Obj.wx_follow.wx_isFollow == 'yes') {
					this.followed = false;
					//console.log(tool.getCookie('wx_follow'))
					if(tool.getCookie(Obj.wx_follow.wx_nameSec)) {
						this.followed = true;
					}
				}
			} else {
				this.delay();
			}

			if(Obj.mobile && this.styleType != 4) { //手机号码
				this.iphoneNum = "tel:" + Obj.mobile.mobile;
				this.isShowCall = true;
				this.ritMenuNum++;
			}

			if(Obj.act_invite) { //邀请
				this.isShowInvitation = true;
				this.ritMenuNum++;
			}

			if(Obj.reward && this.styleType != 4) { //红包
				this.isShowRedPack = true;
				this.ritMenuNum++;
			}
			this.ritNum = this.ritMenuNum;
		}
	}
}
</script>

<style scoped>
	.rightBar {
		position: fixed;
		bottom: 52px;
		right: 10px;
		width: 40px;
		height: 40px;
		line-height: 40px;
		z-index: 1200;
		text-align: center;
	}
	
	.siders {
		transition: height 0.5s;
		position: absolute;
		bottom: 40px;
		left: 0;
		overflow: hidden;
		min-height: 42px;
	}
	
	.siders.hideside {
		height: 0;
	}
	
	.rightBar a {
		display: block;
		width: 40px;
		height: 40px;
		margin-bottom: 6px;
		border-radius: 50%;
		overflow: hidden;
	}
	
	.rightBar a:last-child {
		margin-bottom: 0;
	}
	
	.rightBar a img {
		width: 30px;
		vertical-align: middle;
	}
	
	.rightBar .stretch {
		text-align: center;
		position: absolute;
		bottom: 0px;
		left: 0;
		transition: 0.5s;
	}
	.goldList{
		position: absolute;
		top: -80px;
		left: 0;
		width: 100%;
		min-height: 50px;
		z-index: -1;
	}
	.goldList li{
		position: absolute;
		top:0;
		left: 0;
		width: 100%;
		height: 50px;
	}
	.goldList li img{
		position: absolute;
		left: 10px;
		bottom: 0;
		width: 20px;
		height: 20px;
		opacity: 0;
	}
	.goldList li img.anim1{
		animation: doller1 1s linear;
	}
	.goldList li img.anim2{
		animation: doller2 2s linear;
	}
	.goldList li img.anim3{
		animation: doller3 1s linear;
	}
	.goldList li img.anim4{
		animation: doller4 2s linear;
	}
	@keyframes doller1 {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.5;
		}
		100% {
			opacity: 0;
			transform: translateY(-190px);
			margin-left: 5px;
		}
	}
	@keyframes doller2 {
		0% {
			opacity: 1;
		}
		40% {
			opacity: 0.5;
		}
		100% {
			opacity: 0;
			transform: translateY(-200px);
			margin-left: 15px;
		}
	}
	@keyframes doller3 {
		0% {
			opacity: 1;
		}
		60% {
			opacity: 0.6;
		}
		100% {
			opacity: 0;
			transform: translateY(-210px);
			margin-left: -15px;
		}
	}
	@keyframes doller4 {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.6;
		}
		100% {
			opacity: 0;
			transform: translateY(-220px);
			margin-left: -5px;
		}
	}
	.glodsound{
		position: absolute;
		bottom: 0;
		left: 0;
		opacity: 1;
		z-index: 5000;
	}
	
	
	.code1 {
		background: linear-gradient(#fe9231, #ff7d0a);
	}
	
	.yao2,
	.tel2,
	.shang2,
	.home2,
	.code2,
	.switch2,
	.user2 {
		background: linear-gradient(#e9cf80, #dfab33);
	}
	
	.yao3,
	.shang1,
	.shang3,
	.home3,
	.tel3,
	.code3,
	.switch1,
	.switch3,
	.user1,
	.user3 {
		background: linear-gradient(#fe3535, #ff0000);
	}
	
	.yao1 {
		background: linear-gradient(#238bfe, #007aff);
	}
	
	.tel1 {
		background: linear-gradient(#93d720, #83c714);
	}

	.user4 {
		background: linear-gradient( -90deg,#7d2792, #d36993);
	}
	.switch4{
		background: linear-gradient( -90deg,#5b35d2, #8d2bd9);
	}
	.yao4,.shang4 {
		background:url(https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/Vertical/yao.png) no-repeat center;
		-webkit-background-size: 100%;
		background-size: 100%;
	}
	
	.userimg {
		box-sizing: border-box;
		padding: 2px;
		line-height: 34px;
	}
	
	.rightBar .userimg img {
		width: 100%;
		border-radius: 50%;
	}
	
	.closeside {
		background: linear-gradient(45deg, #d3d3d3, #a0a0a0);
		transform: rotate(135deg);
	}
	
	.codebox {
		line-height: 23px;
		font-size: 16px;
		text-align: center;
	}
	
	.codebox p {
		padding: 0 20px;
	}
	
	.codebox p.title {
		line-height: 60px;
		border-bottom: 1px solid #f0f0f0;
		margin-left: -10px;
		margin-right: -10px;
		font-size: 20px;
		color: #313131;
	}
	
	.codebox .code {
		width: 222px;
		margin: 10px auto 0;
		display: block;
	}
	#qrcode{
		padding: 10px;
	}
	
	.codebox .text {
		color: #909090;
		font-size: 17px;
		margin-bottom: 20px;
	}
	
	.codebox .close {
		width: 17px;
		height: 17px;
	}
	
	.van-popup.codebox {
		border-radius: 5px;
	}
</style>